import { entities } from 'pages/store/schema';
import { getValues } from 'pages/store/selectors';
import { createSelector } from 'reselect';
import filter from 'lodash/filter';
import get from 'lodash/get';
import concat from 'lodash/concat';

export const PaymentTypeTypes = {
  GIFT_CARD: 'gift card',
  CASH: 'cash',
  CREDIT_CARD: 'credit card',
  CREDIT_ACCOUNT: 'credit account',
  USER_DEFINED: 'user defined',
  ECOM: 'ecom',
  ADJUSTMENT: 'adjustment',
};

const PaymentTypeChannels = {
  ONLINE: 'online',
  RETAIL: 'retail',
};

/**
 * Selects all unarchived payments from the store
 *
 * @param {object} state The store state
 */
export const getUnarchivedPaymentTypes = createSelector(
  getValues(entities.paymentType),
  paymentTypes => filter(paymentTypes, paymentType => get(paymentType, 'archived') === 'false')
);

/**
 * Select all unarchived user defined payment types from the store
 *
 * @param {object} state The store state
 */
export const getUserDefinedPaymentTypes = createSelector(
  getUnarchivedPaymentTypes,
  unarchivedPaymentTypes =>
    filter(
      unarchivedPaymentTypes,
      paymentType =>
        get(paymentType, 'type') === PaymentTypeTypes.USER_DEFINED &&
        get(paymentType, 'channel') !== PaymentTypeChannels.ONLINE
    )
);

/**
 * Selects all unarchived credit card payment types from the store
 *
 * @param {object} state The store state
 */
export const getCreditCardPaymentTypes = createSelector(
  getUnarchivedPaymentTypes,
  unarchivedPaymentTypes =>
    filter(
      unarchivedPaymentTypes,
      paymentType => get(paymentType, 'type') === PaymentTypeTypes.CREDIT_CARD
    )
);

/**
 * Selects all credit card mappable payment types
 *
 * @param {object} state The store state
 */
export const getMappablePaymentTypes = createSelector(
  getUserDefinedPaymentTypes,
  getCreditCardPaymentTypes,
  (userDefinedPaymentTypes, creditCardPaymentTypes) =>
    concat(userDefinedPaymentTypes, creditCardPaymentTypes)
);
